module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'blue': '#014487',
                    'dark-blue': '#013060',
                    'light-blue': '#E6ECF3',
                    'orange': '#DA740F',
                }
            },
        },
        fontFamily: {
            montserrat: ['Montserrat', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
